import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./select.html";
import { OptionsInput } from '../common/common';
class Select extends OptionsInput {
  constructor(...args) {
    super(...args);
    this.placeholder = void 0;
    this.emptyLabel = 'Select';
    this.tabIndex = 0;
    this.slotsClasses = {};
  }
  get selectClassCss() {
    return this.stateClassName + ' select';
  }
  handleSlotChange(event) {
    const slot = event.target;
    if (slot.name === 'left') {
      this.template.host.style.setProperty('--ads-border-radius-left', '0px');
    }
    if (slot.name === 'right') {
      this.template.host.style.setProperty('--ads-border-radius-right', '0px');
    }
    this.slotsClasses[slot.name] = slot.assignedElements().length !== 0 ? 'slot ' + slot.name : 'none';
  }
  get placeholderClass() {
    if (!this.value) {
      return 'show-placeholder';
    }
    return '';
  }
  handleChange(event) {
    const target = event.target;
    this.value = target.options[target.selectedIndex].value; // eslint-disable-line @lwc/lwc/no-api-reassignments

    // Re-Dispacth Event
    this.dispatchEvent(new CustomEvent(event.type, {
      detail: this.value,
      bubbles: true,
      composed: true,
      cancelable: true
    }));

    // This fixes Firefox compatibility problems. Read more here: https://stackoverflow.com/a/21541626
    target.selectedIndex = -1;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Select, {
  publicProps: {
    placeholder: {
      config: 0
    },
    emptyLabel: {
      config: 0
    },
    tabIndex: {
      config: 0
    }
  },
  track: {
    slotsClasses: 1
  }
});
const __lwc_component_class_internal = _registerComponent(Select, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;